module.exports = __webpack_public_path__ + "static/media/logo-color.a2a960a9.png";